
import React, { useState } from 'react';
import { motion } from 'framer-motion';

import Modal from "../components/Modal";
import career_image from '../assets/career.png';
import FileUpload from '../components/FileUpload';
import Carousel from '../components/Carousel';
import Footer from '../components/Footer';
import SocialProof from '../components/SocialProof';
import NextSteps from '../components/NextSteps';
import WhyChooseUs from '../components/WhyChooseUs';
import CarouselLanding from '../components/CarouselLanding';

const fadeInUp = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
};

const Home = () => {
  const largeImages = [
    "/landing/upload.jpg",
    "/landing/enquire.jpg",
  ];

  const smallImages = [
    "/landing/upload-small.jpg",
    "/landing/enquire-small.jpg",
  ];

  const feedback = [
    { review: "Excellent service. Useful and valuable tips to make impactful resume. Absolutely empathetic. Highly recommended...", name: "Aditi Bapat", rating: 5 },
    { review: "Thank you for your time, help and effort in restructuring my resume to its new professional standard.", name: "Gaurav Girame", rating: 5 },
    { review: "I am satisfied with your Services and giving Excellent guidelines for Resume making", name: "Ramesh Siripuram", rating: 5 },
    { review: "The experience was very good the process was smooth and every details were explained", name: "Sarika Sarade", rating: 5 },
    { review: "The most transparent, genuine, co-operative and trustworthy firm to interact with. I had the most professional experience while landing a job with Navam Biz Solutions.", name: "Rajat Shetty", rating: 5 },
  ];

  const [isFileUploadOpen, setIsFileUploadOpen] = useState(false);
  const [isEnquiryFormOpen, setIsEnquiryFormOpen] = useState(false);

  const toggleFileUploadModal = () => setIsFileUploadOpen(!isFileUploadOpen);
  const toggleEnquiryFormModal = () => setIsEnquiryFormOpen(!isEnquiryFormOpen);

  return (
    <div>
      <div className="relative space-y-12">

        {/* Carousel Landing */}
        <motion.div
          className="relative w-full h-[60vh] lg:h-[80vh]"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeInUp}
        >
          <CarouselLanding largeImages={largeImages} smallImages={smallImages} />
        </motion.div>

        {/* Why Choose Us */}
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeInUp}
        >
          <WhyChooseUs />
        </motion.div>

        {/* Next Steps */}
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeInUp}
        >
          <NextSteps />
        </motion.div>

        {/* Testimonials */}
        <motion.div
          className="my-6"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeInUp}
        >
          <Carousel feedback={feedback} />
        </motion.div>

        {/* Social Proof */}
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={fadeInUp}
        >
          <SocialProof />
        </motion.div>
        {/* 
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        variants={fadeInUp}
      >
        <Footer />
      </motion.div> */}

      </div>
      <Footer />

    </div>
  );
};

export default Home;

